import { render } from "./gingo-section.vue?vue&type=template&id=236afa9b"
import script from "./gingo-section.vue?vue&type=script&lang=js"
export * from "./gingo-section.vue?vue&type=script&lang=js"

import "./gingo-section.vue?vue&type=style&index=0&id=236afa9b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__